import React from 'react';

export default ({ className, onClick }) => (
  <span className={className} onClick={onClick}>
    <svg x="0px" y="0px" viewBox="0 0 82 82" >
    <path d="M73.28,0.64c1.54,0,3.04,0.81,3.85,2.25c1.19,2.13,0.43,4.81-1.69,6l-57.7,32.33l56.92,31.89
      c2.12,1.19,2.88,3.88,1.69,6c-1.19,2.12-3.88,2.88-6,1.69L6.56,45.07c-1.39-0.78-2.25-2.25-2.25-3.85c0-1.6,0.86-3.07,2.25-3.85
      L71.13,1.2C71.81,0.82,72.55,0.64,73.28,0.64z"/>
    </svg>
  </span>
);
